import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { Box } from '@mui/material';
import { site } from 'apis';
import { useQuery } from 'react-query';

interface SiteAvatarImageProps {
    siteId?: string;
    alt?: string;
    iconSize?: number;
    sx?: any;
}

const SiteAvatarImage = ({ siteId, alt = 'Site image', iconSize = 56, sx }: SiteAvatarImageProps) => {
    const avatarQuery = useQuery(
        ['publicSiteAvatar', siteId],
        async () => {
            if (!siteId) return null;

            try {
                return await site.getPublicSiteAvatar({ id: siteId });
            } catch {
                return null;
            }
        },
        {
            enabled: !!siteId,
            suspense: false,
            staleTime: 1000 * 60 * 15
        }
    );

    const avatarSrc = typeof avatarQuery.data === 'string' && avatarQuery.data.trim() ? avatarQuery.data : '';

    return (
        <Box
            sx={[
                {
                    borderRadius: 2,
                    border: '1px solid #d7e0ea',
                    background:
                        'linear-gradient(135deg, rgba(231, 240, 249, 0.95), rgba(246, 248, 251, 0.95)), radial-gradient(circle at 20% 20%, rgba(80, 135, 180, 0.18), transparent 30%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#7b8b9b',
                    overflow: 'hidden',
                    boxSizing: 'border-box'
                },
                ...(Array.isArray(sx) ? sx : [sx])
            ]}
        >
            {avatarSrc ? (
                <Box component="img" src={avatarSrc} alt={alt} sx={{ width: '100%', height: '100%', objectFit: 'contain', backgroundColor: '#fff' }} />
            ) : (
                <ImageOutlinedIcon sx={{ fontSize: iconSize }} />
            )}
        </Box>
    );
};

export default SiteAvatarImage;
